import React, { FC, useEffect, useState } from "react";
import {
  Wrapper,
  Container,
  DisableButton,
  ModalWrapper,
  ModalMessege,
  ModalAction,
  ModalImg,
} from "./StyledCoinList";
import * as TableStyle from "../Lottery/LotteryList/StyledLottery";
import ViewHeader from "../../components/ViewHeader/ViewHeader";
import TableHeaderComponent from "../../components/TableHeader/TableHeader";
import Button from "../../components/UI/Button/Button";

import useDimension from "../../costomHook/useDimention";
import * as UIConstants from "../../UIConstants";
import { adminRouts } from "../../routs";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCoin,
  getCoins,
  getCoinsById,
  publishCoin,
} from "../../features/coinSlice";
import { RootState } from "../../app/Store";
import { searchTableData, tablePagination } from "../../Utility/Utility";
import EmptyTableView from "../../components/EmptyTableView/EmptyTableView";
import TableFooter from "../../components/TableFooter/TableFooter";
import { togglePublish } from "../../features/loader";
import {
  resetImages,
  resetThumbnail,
  setImages,
  setThumbnail,
} from "../../features/imageUploaderSlice";

import Modal from "../../components/Modal/Modal";
import warning from "../../assets/images/warningSign.png";
import JsonToCsv from "../../components/JSONToCSV/JsonToCsv";


enum ButtonSize {
  sm = "small",
  md = "medium",
  lg = "large",
}
enum ButtonVariant {
  primaryFilled = "primary-filled",
  secondary = "secondary",
  primaryLink = "primaryLink",
  danger = "danger",
  dangerOutline="dangerOutline"
}

class TableHeader {
  constructor(
    public label: string,
    public isSortRequired: boolean,
    public isAscSorted: boolean,
    public isDscSorted: boolean,
    public id: string
  ) {}
}
let tableHeaders = [
  new TableHeader("Coin ID", false, false, false, "coinId"),
  new TableHeader("Coin Code", false, false, false, "coinId"),
  new TableHeader("Title", false, false, false, "coinTitle"),
  new TableHeader("Price", false, false, false, "coinPrice"),
  // new TableHeader("Description", false, false, false, "coinDescription"),
];
const CoinList: FC = () => {
  const [tableHeaderValues, setHeaderValues] = useState(tableHeaders);
  const dimention = useDimension();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const mainList = useSelector((state: RootState) => state.coin.coins);
  const coinList = [...mainList].reverse();

  // const singleCoin = useSelector((state: RootState) => state.coin.singleCoin);
  const [originalResponse, setOriginalResponse] = useState<any>([]);
  const [totalResponseLength, setResponseLength] = useState(0);
  const [responseData, setResponseData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [tableSearch, setSearch] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [deleteCoinId, setDeleteCoinId] = useState(0);

  // useEffect(() => {
  //   dispatch(getCoins());
  // }, [singleCoin]);
  useEffect(() => {
    dispatch(getCoins());
  }, []);

  useEffect(() => {
    if (coinList.length > 0) {
      setResponseLength(coinList.length);
      setOriginalResponse(coinList);
      let pagedResponse = tablePagination(coinList, 1);
      if (pagedResponse.isValidResponse) {
        setResponseData(pagedResponse.data);
      } else {
        setResponseData([]);
      }
    }
  }, [mainList]);

  const redirectToView = (path: string) => {
    navigate(path);
  };

  const redirectToDetailView = (coinId: number) => {
    navigate(adminRouts.updateCoin(coinId));
    // console.log(coinId);
  };

  const updatePageNumber = (pageNumber) => {
    if (originalResponse.length > 0) {
      let pagedResponse = tablePagination(originalResponse, pageNumber);
      if (pagedResponse.isValidResponse) {
        setPageNumber(pagedResponse.pageNumber);
        setResponseData(pagedResponse.data);
      }
    }
  };

  const deteCoinHandler = (id: number) => {
    setOpenModal(true);
    setDeleteCoinId(id);
  };
  const confirmDelete = () => {
    // console.log(id)
    dispatch(deleteCoin(deleteCoinId));
    dispatch(getCoinsById(deleteCoinId));
    setOpenModal(false);
  };

  const publishCoinHandler = (id: number) => {
    dispatch(publishCoin(id));
    
  };

  const tableBody = responseData.map((tableRowObj: any) => {
    // console.log(tableRowObj);

    let idBtn = (
      <Button
        title={`${tableRowObj.coinId}`}
        btnSize={ButtonSize.sm}
        btnVariant={ButtonVariant.primaryLink}
        clicked={() => {
          redirectToDetailView(tableRowObj.coinId);
        }}
      />
    );

    return (
      <tr>
        <td>{idBtn}</td>
        <td>{tableRowObj.coinCode}</td>
        <td>{tableRowObj.coinTitle}</td>
        <td>{tableRowObj.coinPrice}</td>
        {/* <td style={{width:"40%"}}>{tableRowObj.coinDescription}</td> */}
        <td>
          <Button
            title={"Delete"}
            btnSize={
              dimention.width >= UIConstants.customWidth
                ? ButtonSize.md
                : ButtonSize.sm
            }
            btnVariant={ButtonVariant.danger}
            clicked={() => deteCoinHandler(tableRowObj.coinId)}
          />
        </td>
        <td>
          
            <Button
              title={!tableRowObj.isPublished ?"Publish":"Hold"}
              btnSize={
                dimention.width >= UIConstants.customWidth
                  ? ButtonSize.md
                  : ButtonSize.sm
              }
              btnVariant={!tableRowObj.isPublished?ButtonVariant.secondary:ButtonVariant.dangerOutline}
              clicked={() => publishCoinHandler(tableRowObj.coinId)}
            />
          
        </td>
      </tr>
    );
  });

  const setTableSearchValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  const triggerSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      let searchResponse = searchTableData(originalResponse, tableSearch);
      if (searchResponse.length > 0) {
        setResponseData(searchResponse);
        setPageNumber(1);
        setResponseLength(searchResponse.length);
      }
    }
  };

  return (
    <Wrapper>
      <Container>
        <Modal
          isOpen={openModal}
          name={"Create dele coin Modal"}
          title={"Delete Coin"}
          toggleModal={() => setOpenModal(false)}
        >
          <ModalWrapper>
            <ModalImg>
              <img
                src={warning}
                alt="warning"
                width={"150px"}
                height={"150px"}
              />
            </ModalImg>
            <ModalMessege>
              Are you sure, You want to delete this Coin?
            </ModalMessege>
            <ModalAction>
              <Button
                title={"Cancel"}
                btnSize={ButtonSize.md}
                btnVariant={ButtonVariant.dangerOutline}
                clicked={() => setOpenModal(false)}
              />
              <Button
                title={"Okay"}
                btnSize={ButtonSize.md}
                btnVariant={ButtonVariant.danger}
                clicked={confirmDelete}
              />
            </ModalAction>
          </ModalWrapper>
        </Modal>
        <TableStyle.BreadcrumbSection>
          <ViewHeader title={"Coins"} />
          <TableStyle.HeaderBtn>
          <Button
            title={"+ Create Coins"}
            btnSize={
              dimention.width >= UIConstants.customWidth
                ? ButtonSize.md
                : ButtonSize.sm
            }
            btnVariant={ButtonVariant.primaryFilled}
            clicked={() => {
              redirectToView(adminRouts.createCoins);
            }}
          />
          <JsonToCsv fileLabel={"Coin"} data={coinList}/>
          </TableStyle.HeaderBtn>
        </TableStyle.BreadcrumbSection>
      </Container>
      <TableStyle.ContentSection>
        <TableStyle.SearchSectionContainer>
          <TableStyle.Input
            value={tableSearch}
            onKeyDown={triggerSearch}
            onChange={setTableSearchValue}
            placeholder="Search"
          />
        </TableStyle.SearchSectionContainer>
        <TableStyle.TabMenuContainer>
          {/* tabMenuViw */}
        </TableStyle.TabMenuContainer>
        <TableStyle.TableWrapper>
          <TableStyle.Table>
            <TableHeaderComponent
              headers={tableHeaderValues}
              onToggleSort={() => {}}
            />
            <TableStyle.Tbody>{tableBody}</TableStyle.Tbody>
          </TableStyle.Table>
          {responseData.length === 0 && <EmptyTableView />}
          <TableFooter
            totalCount={totalResponseLength}
            currentPageNumber={pageNumber}
            updatePageNumber={updatePageNumber}
          />
        </TableStyle.TableWrapper>
      </TableStyle.ContentSection>
    </Wrapper>
  );
};

export default CoinList;
